const alphaListLinePattern = /^(\s*)([a-zA-Z])\.\s+(.+)$/;

export const preprocessAlphabeticLists = (content: string) => {
  const lines = content.split('\n');
  const output: string[] = [];

  for (let index = 0; index < lines.length; ) {
    const match = lines[index].match(alphaListLinePattern);
    if (!match) {
      output.push(lines[index]);
      index += 1;
      continue;
    }

    const [, indent, firstLetter, firstItem] = match;
    const isLowerCase = firstLetter === firstLetter.toLowerCase();
    const start = firstLetter.toLowerCase().charCodeAt(0) - 96;
    const typeAttr = isLowerCase ? 'a' : 'A';

    const items: string[] = [firstItem];
    index += 1;
    while (index < lines.length) {
      const nextMatch = lines[index].match(alphaListLinePattern);
      if (!nextMatch || nextMatch[1] !== indent) {
        break;
      }
      items.push(nextMatch[3]);
      index += 1;
    }

    const startAttr = start > 1 ? ` start="${start}"` : '';
    output.push(`${indent}<ol type="${typeAttr}"${startAttr}>`);
    for (const item of items) {
      output.push(`${indent}  <li>${item}</li>`);
    }
    output.push(`${indent}</ol>`);
  }

  return output.join('\n');
};
